import React from "react";
import "./GlobalLoader.css";

const ThreeDotsLoader = () => {
  return <span className="loader"></span>;
};

export default ThreeDotsLoader;
